:host {
  @apply block;
}

:host([custom-styles=false]) {
  ::slotted([slot=items]) {
    @apply py-3 h-fit;
  }
}
